import { RecentActivityScreen } from '@/screens/diamonds/RecentActivityScreen'

export default function () {
  return <RecentActivityScreen />
}
